<template>
  <div class="copyFooter" :data-theme="themeMode">{{ $t('h.common.copy') }}</div>
</template>

<script >
export default {
  computed: {
    themeMode() {
      window.document.documentElement.setAttribute("data-theme", this.$store.state.subject === 'dark' ? 'dark' : 'light');
      return this.$store.state.subject === 'dark' ? 'dark' : 'light';
    }
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/common.scss';

.copyFooter {
  @include font_color("copyFooterColor");
  font-size: 12px;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/copyright/copyright.vue